import { TTraderRateField } from '../model/types';

export const TRADER_RATE_MAX: Record<TTraderRateField, number> = {
  reward_percent: 15,
  referral_reward_percent: 3,
};

export const validateTraderRate = (value: string, field: TTraderRateField): string => {
  const max = TRADER_RATE_MAX[field];
  const num = Number(value);

  if (!value.trim() || !Number.isFinite(num)) return 'Enter a number';
  if (num < 0 || num > max) return `Value must be between 0 and ${max}`;

  return '';
};
